import React, { useState, useEffect } from 'react';

const AnimatedText = () => {
  const [displayText, setDisplayText] = useState('');
  const steps = [
    'I',
    'I A',
    'I AM',
    'I AM ',
    'I AM A',
    'I AM A I',
    'I AM Al I',
    'I AM Alw I',
    'I AM Alwa I',
    'I AM Alway I',
    'I AM Always I ',
    'I AM Always Im',
    'I AM Always Imp',
    'I AM Always Impr',
    'I AM Always Impro',
    'I AM Always Improv',
    'I AM Always Improvi',
    'I AM Always Improvin',
    'I AM Always Improving 🚀',
  ];

  useEffect(() => {
    let index = 0;
    const interval = setInterval(() => {
      if (index < steps.length) {
        setDisplayText(steps[index]);
        index++;
      } else {
        clearInterval(interval);
      }
    }, 200); // Adjust the speed by changing the delay (500ms here).

    return () => clearInterval(interval); // Cleanup interval on unmount.
  }, []);

  return <div className="fredoka text-lg italic">{displayText}</div>;
};

export default AnimatedText;
